"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationsClearArchived = exports.NOTIFICATIONS_CLEAR_ARCHIVED = exports.notificationsClearAllPossible = exports.NOTIFICATIONS_CLEAR_ALL_POSSIBLE = exports.loadHistoryNotifications = exports.LOAD_HISTORY_NOTIFICATIONS = exports.setHistoryNotificationsLimit = exports.SET_HISTORY_NOTIFICATIONS_LIMIT = exports.notificationsClearByNamespaces = exports.NOTIFICATIONS_CLEAR_BY_NAMESPACES = exports.notificationsClearByNamespace = exports.NOTIFICATIONS_CLEAR_BY_NAMESPACE = exports.notificationRemove = exports.NOTIFICATION_REMOVE = exports.notificationPush = exports.NOTIFICATION_PUSH = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

var _createAction = require("../base/create-action");

var _getActionName = require("../utils/get-action-name");

var _combineLocations = require("./combine-locations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MODULE_NAME = 'skybase-ui';
/**
 * Inject the redirect locations to a notification and re-generate it's ID
 * when multiple locations are given to one namespace, to avoid duplicate keys.
 * @param notification
 * @returns {*}
 */

var injectLocations = function injectLocations(notification) {
  var namespace = notification.namespace || null;
  var redirectLocations = (0, _combineLocations.getLocations)();

  if (namespace && redirectLocations[namespace]) {
    var locations = redirectLocations[namespace];
    return locations.reduce(function (acc, location) {
      acc.push(_objectSpread(_objectSpread({}, notification), {}, {
        location: location,
        id: (0, _v.default)()
      }));
      return acc;
    }, []);
  }

  return notification;
};

var NOTIFICATION_PUSH = (0, _getActionName.getActionName)('NOTIFICATION_PUSH', MODULE_NAME);
exports.NOTIFICATION_PUSH = NOTIFICATION_PUSH;

var notificationPush = function notificationPush(notification) {
  return (0, _createAction.createAction)(NOTIFICATION_PUSH, {
    notification: injectLocations(notification)
  });
};

exports.notificationPush = notificationPush;
var NOTIFICATION_REMOVE = (0, _getActionName.getActionName)('NOTIFICATION_REMOVE', MODULE_NAME);
exports.NOTIFICATION_REMOVE = NOTIFICATION_REMOVE;

var notificationRemove = function notificationRemove(id) {
  return (0, _createAction.createAction)(NOTIFICATION_REMOVE, {
    id: id
  });
};

exports.notificationRemove = notificationRemove;
var NOTIFICATIONS_CLEAR_BY_NAMESPACE = (0, _getActionName.getActionName)('NOTIFICATIONS_CLEAR_BY_NAMESPACE', MODULE_NAME);
exports.NOTIFICATIONS_CLEAR_BY_NAMESPACE = NOTIFICATIONS_CLEAR_BY_NAMESPACE;

var notificationsClearByNamespace = function notificationsClearByNamespace(namespace) {
  return (0, _createAction.createAction)(NOTIFICATIONS_CLEAR_BY_NAMESPACE, {
    namespace: namespace
  });
};

exports.notificationsClearByNamespace = notificationsClearByNamespace;
var NOTIFICATIONS_CLEAR_BY_NAMESPACES = (0, _getActionName.getActionName)('NOTIFICATIONS_CLEAR_BY_NAMESPACES', MODULE_NAME);
exports.NOTIFICATIONS_CLEAR_BY_NAMESPACES = NOTIFICATIONS_CLEAR_BY_NAMESPACES;

var notificationsClearByNamespaces = function notificationsClearByNamespaces(namespaces) {
  return (0, _createAction.createAction)(NOTIFICATIONS_CLEAR_BY_NAMESPACES, {
    namespaces: namespaces
  });
};

exports.notificationsClearByNamespaces = notificationsClearByNamespaces;
var SET_HISTORY_NOTIFICATIONS_LIMIT = (0, _getActionName.getActionName)('SET_HISTORY_NOTIFICATIONS_LIMIT', MODULE_NAME);
exports.SET_HISTORY_NOTIFICATIONS_LIMIT = SET_HISTORY_NOTIFICATIONS_LIMIT;

var setHistoryNotificationsLimit = function setHistoryNotificationsLimit(limit) {
  return (0, _createAction.createAction)(SET_HISTORY_NOTIFICATIONS_LIMIT, {
    limit: limit
  });
};

exports.setHistoryNotificationsLimit = setHistoryNotificationsLimit;
var LOAD_HISTORY_NOTIFICATIONS = (0, _getActionName.getActionName)('LOAD_HISTORY_NOTIFICATIONS', MODULE_NAME);
exports.LOAD_HISTORY_NOTIFICATIONS = LOAD_HISTORY_NOTIFICATIONS;

var loadHistoryNotifications = function loadHistoryNotifications(history) {
  return (0, _createAction.createAction)(LOAD_HISTORY_NOTIFICATIONS, {
    history: history
  });
};

exports.loadHistoryNotifications = loadHistoryNotifications;
var NOTIFICATIONS_CLEAR_ALL_POSSIBLE = (0, _getActionName.getActionName)('NOTIFICATIONS_CLEAR_ALL_POSSIBLE', MODULE_NAME);
exports.NOTIFICATIONS_CLEAR_ALL_POSSIBLE = NOTIFICATIONS_CLEAR_ALL_POSSIBLE;

var notificationsClearAllPossible = function notificationsClearAllPossible() {
  return (0, _createAction.createAction)(NOTIFICATIONS_CLEAR_ALL_POSSIBLE, {});
};

exports.notificationsClearAllPossible = notificationsClearAllPossible;
var NOTIFICATIONS_CLEAR_ARCHIVED = (0, _getActionName.getActionName)('NOTIFICATIONS_CLEAR_ARCHIVED', MODULE_NAME);
exports.NOTIFICATIONS_CLEAR_ARCHIVED = NOTIFICATIONS_CLEAR_ARCHIVED;

var notificationsClearArchived = function notificationsClearArchived() {
  return (0, _createAction.createAction)(NOTIFICATIONS_CLEAR_ARCHIVED, {});
};

exports.notificationsClearArchived = notificationsClearArchived;
//# sourceMappingURL=actions.js.map